import util from '@/libs/util.js'
// import Vue from 'vue'
import get from 'lodash.get'
import protobuf from 'protobufjs'
import { Message } from 'element-ui'
import _protoRoot from '../proto/biz-proto/index'
const ErrorMessage = Message.error

function isArrayBuffer (obj) {
  return Object.prototype.toString.call(obj) === '[object ArrayBuffer]'
}
/**
 * 请求体序列化
 * @param {string} requestType 请求体buf类型
 */
function transformReqeustFactory (protoRoot, requestType) {
  /**
   * 请求参数序列化
   */
  return function transformResponse (rawData) {
    // 非空校验
    if (!rawData) {
      return rawData
    }
    try {
      const PBMessageData = protoRoot.lookup(requestType)
      var message = PBMessageData.create(rawData)
      var decodedDataBuffer = PBMessageData.encode(message).finish()
      console.log(PBMessageData.decode(decodedDataBuffer))
      return decodedDataBuffer
    } catch (err) {
      return err
    }
  }
}
/**
 * response反序列化
 * @param {string} responseType 返回值buf类型
 */
function transformResponseFactory (protoRoot, responseType) {
  return function transformResponse (rawResponse) {
    // 判断response是否是arrayBuffer
    if (rawResponse == null || !isArrayBuffer(rawResponse)) {
      return rawResponse
    }
    try {
      const buf = protobuf.util.newBuffer(rawResponse)
      // decode响应体
      const PBMessageResponse = protoRoot.lookup(responseType)
      const decodedResponse = PBMessageResponse.decode(buf)
      return decodedResponse
    } catch (err) {
      return err
    }
  }
}

/**
 * @param {*} msgType 接口名称
 * @param {*} requestBody 请求体参数
 * @param {*} responseType 返回值
 */
async function request (options = {}, config = {}) {
  const lookupTypePathResponse = get(config, 'PB_LOOK_TYPE_PATH_RESPONSE')
  const lookupTypePathRequest = get(config, 'PB_LOOK_TYPE_PATH_REQUEST')
  const tokenRequired = get(config, 'TOKEN_REQUIRED') // syx开始处理登陆事宜！
  const errAction = get(config, 'ERROR_ACTION') // 异常处理
  // const protoModule = get(config, 'PROTO_MODULE') // 异常处理
  const protoRoot = _protoRoot
  // const { default: protoRoot } = await protoRootMapper[protoModule]()
  const errorMessage = (message) => errAction === 'message' && ErrorMessage(message)
  const requestBody = transformReqeustFactory(protoRoot, lookupTypePathRequest)(options.data || {})
  // console.log('.., proto requestBody', requestBody)
  const { url, method = 'GET', headers = {} } = options
  const headers2 = tokenRequired ? {
    ...{
      'Content-Type': 'application/x-protobuf',
      Authorization: util.cookies.get('token')
    },
    ...headers
  } : {
    ...{
      'Content-Type': 'application/x-protobuf'
      // 'Authorization': 'elIuFgmrgycjaZbD'
    },
    ...headers
  }
  const fetchParams = {
    method,
    headers: headers2
  }
  if (method !== 'GET') fetchParams.body = requestBody
  return new Promise((resolve, reject) => {
    fetch(
      url,
      fetchParams
    ).then(res => {
      const { status: httpStatus } = res
      if (httpStatus === 200) {
        // arrayBuffer 转换 很关键
        return res.arrayBuffer()
      } else if (httpStatus === 401) {
        // todo 后期兼容token 和重定向登陆
        // return {
        //   errorCode: 500,
        //   errorMsg: '未登录，暂未实现，请联系开发者~~'
        // }
        errorMessage('未登录，暂未实现，请联系开发者~~')
        return undefined
      } else {
        // return {
        //   errorCode: 500,
        //   errorMsg: '服务异常，请稍后重试~~'
        // }
        errorMessage('服务异常，请稍后重试~~')
        return undefined
      }
    }, err => {
      console.log('!!!!!!!!!!!err' + err)
    }).then(response => {
      console.log('!!!!!!!!!!!!', response)
      if (!response) {
        // errorMessage('服务异常，请稍后重试~~~')
        throw new Error('服务异常，请稍后重试~~~')
        // return
      }
      try {
        const resObj = transformResponseFactory(protoRoot, lookupTypePathResponse)(response)
        const { errorMsg, errorCode } = resObj
        console.log('...... 反序列化', resObj)
        if (errorCode === 0) {
          resolve(resObj)
        } else if ([100000002].includes(errorCode)) {
          // todo 后期兼容token 和重定向登陆
          errorMessage('未登录，暂未实现，请联系开发者~~')
        } else {
          errorMessage(errorMsg || '接口异常，请稍后重试~~')
          resolve(resObj)
        }
      } catch (e) {
        console.log('e', e)
        errorMessage('序列化出错，请联系开发者~~')
        console.log('@@ 反序列化失败')
      }
    }).catch((err) => {
      console.warn(err)
      errorMessage('网络异常~~')
      throw new Error('网络异常~~')
    })
  })
}

export default request
